import documentApi from "services/api/documentApi";

/* Service class used to perform api calls for messaging */
class DoxExplorerCDMServices {

    formatFileSize(fileSizeBytes) {
        var ss = '-'
        if (fileSizeBytes) {
            if (fileSizeBytes < 1024) {
                ss = `${fileSizeBytes} bytes`
            } else if (fileSizeBytes < 1024 * 1024) {
                ss = `${Math.round(fileSizeBytes / 1024)} KB`
            } else {
                ss = `${Math.round(fileSizeBytes / (1024 * 1024))} MB`
            }
        }
        return ss;
    }

    getTruncatedFileName(fileName, fileType, isMobile) {
        var nameLen = (fileName || '').length
        var extLen = (fileType || '').length
        var maxLen = isMobile ? 30 : 38;
        if (nameLen + extLen > maxLen) {
            return (fileName || '').substring(0, maxLen - extLen - 3) + '...' + (fileType || '');
        } else {
            return `${fileName || ''}${fileType || ''}`
        }
    }

    getLabelKeyForUploader(uploaderIsBlock) {
        return uploaderIsBlock ? 'Dox.DocumentExplorer.Block' : uploaderIsBlock === false ? 'Dox.DocumentExplorer.You' : null;
    }

    api(handleUnauthorized) {
        return documentApi.create(handleUnauthorized);
    }


    /**
    * Retrieves the specified file data
     * @param {Function} handleUnauthorized
     * @param {string|number} taxYear
    */
    async getFileList(handleUnauthorized, ticketId) {
        return await this.api(handleUnauthorized).getFiles(ticketId);
    }

    /**
    * Retrieves the specified file data, then sorts it by the given params
    * @param {Function} handleUnauthorized
    * @param {string|number} ticketId
    * @param {string} sortColumn
    * @param {boolean} sortDirection
    */
    async getSortedFileList(handleUnauthorized, ticketId, sortColumn, sortDirection) {
        let { status, fileList } = await this.getFileList(handleUnauthorized, ticketId)

        if (status) {
            fileList = this.sortFileList(fileList, sortColumn, sortDirection);
        }

        return { status, fileList }
    }

    sortFileList = (file_list, sortColumn, sortDirection) => {
        let fileList = file_list;
        if (sortColumn === 'name') {
            fileList = fileList.sort((a, b) => (a.fileName || '').localeCompare(b.fileName))
        } else if (!sortColumn || sortColumn === 'modified') {
            fileList = fileList.sort((a, b) => -(new Date(a.modifiedTs).getTime() - new Date(b.modifiedTs).getTime()));
        } else if (sortColumn === 'size') {
            fileList = fileList.sort((a, b) => -((a.fileSize || 0) - (b.fileSize || 0)))
        } else if (sortColumn === 'uploader') {
            fileList = fileList.sort((a, b) => (a.uploaderName || '').localeCompare(b.uploaderName || ''))
        }

        if (sortDirection) {
            fileList = fileList.reverse();
        }
        return [...fileList];
    }

    /**
     * Retrieves the specified file data
     * @param {any} handleUnauthorized
     * @param {any} documentId
     */
    async deleteFile(handleUnauthorized, documentId) {
        if (!documentId) {
            return false;
        }
        let response = await this.api(handleUnauthorized).deleteFile(documentId);
        return response?.status === 200 && response.data.isSuccessful;
    }

    /**
     * Retrieves the specified file data
     * @param {any} handleUnauthorized
     * @param {any} documentId
     * @param {any} ticketId
     * @param {any} request
     */
    async updateFileMetadata(handleUnauthorized, documentId, ticketId, request) {
        if (!documentId) {
            return false;
        }
        var response = await this.api(handleUnauthorized).updateFileInfo(ticketId, documentId, request);
        return response?.status === 200 && response.data.isSuccessful;
    }

    async recoverFile(handleUnauthorized, documentId){
        if (!documentId) {
            return false
        }       

        var response = await this.api(handleUnauthorized).recoverFile(documentId);        
        return response?.status === 200 && response.data.isSuccessful;
    }
}

const doxExplorerCDMServices = new DoxExplorerCDMServices();
export default doxExplorerCDMServices;